import { render, staticRenderFns } from "./yingjiFooter.vue?vue&type=template&id=da16f532&scoped=true"
import script from "./yingjiFooter.vue?vue&type=script&lang=js"
export * from "./yingjiFooter.vue?vue&type=script&lang=js"
import style0 from "./yingjiFooter.vue?vue&type=style&index=0&id=da16f532&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da16f532",
  null
  
)

export default component.exports